import './SalesforceUserSelector.scss';
import { SalesforceUser } from './SalesforceUser';
import { SonarSelector } from './SonarSelector';
import { Space } from 'antd';
import { useSalesforceUsers } from '@hooks';
import React, { useCallback, useMemo } from 'react';
export const SalesforceUserSelector = ({ allowReadonly, avatar, direction = 'vertical', disabled, getPopupContainer, id, isSpreadsheet, onChange, placeholder, value }) => {
    const users = useSalesforceUsers();
    const userNames = useMemo(() => users === null || users === void 0 ? void 0 : users.reduce((names, user) => {
        names[user.username] = user.name;
        return names;
    }, {}), [users]);
    const selectedUsers = useMemo(() => {
        if (value) {
            return Array.isArray(value) ? value : [value];
        }
        return [];
    }, [value]);
    const placeholderNode = useMemo(() => React.createElement(SalesforceUser, { avatar: avatar, placeholder: placeholder, username: '' }), [avatar, placeholder]);
    const options = useMemo(() => {
        var _a;
        return (_a = users === null || users === void 0 ? void 0 : users.filter((user) => user.username)) === null || _a === void 0 ? void 0 : _a.map((user) => ({
            label: React.createElement(SalesforceUser, { avatar: avatar, name: user.name, username: user.username }),
            optionLabel: React.createElement(SalesforceUser, { avatar: avatar, name: user.name, showTooltip: true, username: user.username }),
            searchValue: user.name,
            value: user.username
        }));
    }, [users, avatar]);
    const readOnlyDisplay = useMemo(() => React.createElement(Space, { direction: direction, size: 4, wrap: true }, selectedUsers.map((username) => React.createElement(SalesforceUser, { key: username, name: userNames === null || userNames === void 0 ? void 0 : userNames[username], showTooltip: true, username: username }))), [direction, selectedUsers, userNames]);
    const handleOnChange = useCallback((values) => {
        if (onChange) {
            onChange(values);
        }
    }, [onChange]);
    return (React.createElement(SonarSelector, { allowReadonly: allowReadonly, className: 'salesforce-user-selector', disabled: disabled, getPopupContainer: getPopupContainer, id: id, isSpreadsheet: isSpreadsheet, mode: 'multiple', onChange: handleOnChange, options: options, placeholder: placeholderNode, popupClassName: 'salesforce-user-space-conscious-label', readOnlyDisplay: (value === null || value === void 0 ? void 0 : value.length) ? readOnlyDisplay : null, value: selectedUsers }));
};
